// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  background-position: center bottom;
  --background: #f0f6f9 url('student-bg.svg')
    no-repeat center bottom / cover;
}

ion-item {
  --ion-background-color: #fff;
}

.item-has-focus {
  --highlight-background: #e2e2e2;
}

@media (max-width: 540px) {
  ion-content {
    background-position: center bottom;
    --background: #f0f6f9 url('student-bg.svg')
      no-repeat center bottom / cover;
  }
  ion-item {
    --ion-background-color: #fff;
  }
  h1 {
    font-size: 8vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: center;
  }
}
@media (min-width: 720px) {
  h1 {
    font-size: 8vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: center;
  }
}
@media (min-width: 960px) {
  h1 {
    font-size: 2vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: center;
  }
}
ion-item ion-icon {
  color: #fcd116;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/forgot/forgot.page.scss","webpack://./../saferoadsph-ui-mysql%20-%20odep/src/app/pages/home/forgot/forgot.page.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA;mCAAA;ACEF;;ADCA;EACE,4BAAA;ACEF;;ADCA;EACE,+BAAA;ACEF;;ADCA;EACE;IACE,kCAAA;IACA;qCAAA;ECGF;EDAA;IACE,4BAAA;ECEF;EDCA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,kBAAA;ECCF;AACF;ADEA;EACE;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,kBAAA;ECAF;AACF;ADGA;EACE;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,kBAAA;ECDF;AACF;ADIA;EACE,cAAA;ACFF","sourcesContent":["ion-content {\r\n  background-position: center bottom;\r\n  --background: #f0f6f9 url(\"../../../../assets/img/layout/student-bg.svg\")\r\n    no-repeat center bottom / cover;\r\n}\r\nion-item {\r\n  --ion-background-color: #fff;\r\n}\r\n\r\n.item-has-focus {\r\n  --highlight-background: #e2e2e2;\r\n}\r\n\r\n@media (max-width: 540px) {\r\n  ion-content {\r\n    background-position: center bottom;\r\n    --background: #f0f6f9 url(\"../../../../assets/img/layout/student-bg.svg\")\r\n      no-repeat center bottom / cover;\r\n  }\r\n  ion-item {\r\n    --ion-background-color: #fff;\r\n  }\r\n\r\n  h1 {\r\n    font-size: 8vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n@media (min-width: 720px) {\r\n  h1 {\r\n    font-size: 8vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n@media (min-width: 960px) {\r\n  h1 {\r\n    font-size: 2vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\nion-item ion-icon {\r\n  color: #fcd116;\r\n}\r\n","ion-content {\n  background-position: center bottom;\n  --background: #f0f6f9 url(\"../../../../assets/img/layout/student-bg.svg\")\n    no-repeat center bottom / cover;\n}\n\nion-item {\n  --ion-background-color: #fff;\n}\n\n.item-has-focus {\n  --highlight-background: #e2e2e2;\n}\n\n@media (max-width: 540px) {\n  ion-content {\n    background-position: center bottom;\n    --background: #f0f6f9 url(\"../../../../assets/img/layout/student-bg.svg\")\n      no-repeat center bottom / cover;\n  }\n  ion-item {\n    --ion-background-color: #fff;\n  }\n  h1 {\n    font-size: 8vw;\n    font-family: \"Otomanopee One\", sans-serif;\n    color: #292822;\n    text-align: center;\n  }\n}\n@media (min-width: 720px) {\n  h1 {\n    font-size: 8vw;\n    font-family: \"Otomanopee One\", sans-serif;\n    color: #292822;\n    text-align: center;\n  }\n}\n@media (min-width: 960px) {\n  h1 {\n    font-size: 2vw;\n    font-family: \"Otomanopee One\", sans-serif;\n    color: #292822;\n    text-align: center;\n  }\n}\nion-item ion-icon {\n  color: #fcd116;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
